var JoyActivityEvent;
(function (JoyActivityEvent) {
    JoyActivityEvent["albumCreated"] = "albumCreated";
    JoyActivityEvent["mediumsAddedToAlbum"] = "mediumsAddedToAlbum";
    JoyActivityEvent["mediumsAddedToGroup"] = "mediumsAddedToGroup";
    JoyActivityEvent["commentAded"] = "commentAded";
    JoyActivityEvent["userAdded"] = "userAdded";
})(JoyActivityEvent || (JoyActivityEvent = {}));
export default JoyActivityEvent;
//# sourceMappingURL=JoyActivityEvent.js.map